import { Directive, ElementRef, Renderer2, HostListener } from '@angular/core'
import { fromEvent, throttleTime } from 'rxjs'

@Directive({
  selector: '[draggable]',
})
export class DraggableDirective {
  private isDragging: boolean = false
  private startX: number = 0
  private startY: number = 0

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  @HostListener('mousedown', ['$event']) onMouseDown(event: MouseEvent) {
    this.isDragging = true
    this.startX = event.clientX - this.el.nativeElement.offsetLeft
    this.startY = event.clientY - this.el.nativeElement.offsetTop

    fromEvent(document, 'mousemove')
      .pipe(throttleTime(10))
      .subscribe((moveEvent: any) => {
        this.onMouseMove(moveEvent)
      })
  }

  @HostListener('document:mouseup') onMouseUp() {
    this.isDragging = false
  }

  private onMouseMove(event: MouseEvent) {
    if (this.isDragging) {
      const newX = event.clientX - this.startX
      const newY = event.clientY - this.startY
      this.renderer.setStyle(this.el.nativeElement, 'left', `${newX}px`)
      this.renderer.setStyle(this.el.nativeElement, 'top', `${newY}px`)
    }
  }
}
